<div class="question-wrapper" id="QuestionWraper">
  <div class="">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="text-center without-help text-02-m-light text-01-d-light title">¿Cuándo tienes pensado contratar o renovar tu póliza?</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-4 col-xs-3">
        <div class="form-control select" id="divDay_PolicyStartRealDate" [class.error]="!validDateOption.isValidDay || !validDateOption.isValidDate">
          <div class="select-wrapper">
            <select name="PolicyStartRealDate_day" id="PolicyStartRealDate_day" [(ngModel)]="selectedDate.day" class="inline">
              <option *ngFor="let day of dateOptionsModel.days" [value]="day.Value">{{ day.Text }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-6">
        <div class="form-control select" id="divMonth_PolicyStartRealDate" [class.error]="!validDateOption.isValidMonth || !validDateOption.isValidDate">
          <div class="select-wrapper">
            <select name="PolicyStartRealDate_month" id="PolicyStartRealDate_month" [(ngModel)]="selectedDate.month" class="inline">
              <option *ngFor="let month of dateOptionsModel.months" [value]="month.Value">{{ month.Text }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-3">
        <div class="form-control select" id="divYear_PolicyStartRealDate" [class.error]="!validDateOption.isValidYear || !validDateOption.isValidDate">
          <div class="select-wrapper">
            <select name="PolicyStartRealDate_year" id="PolicyStartRealDate_year" [(ngModel)]="selectedDate.year" class="inline">
              <option *ngFor="let year of dateOptionsModel.years" [value]="year.Value">{{ year.Text }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-4 col-xs-12 error date day" id="errorDay">
        <div [hidden]="validDateOption.isValidDay">{{ sWErrorMessage.invalidDay }}</div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12 error date month" id="errorMonth">
        <div [hidden]="validDateOption.isValidMonth">{{ sWErrorMessage.invalidMonth }}</div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12 error date year" id="errorYear">
        <div [hidden]="validDateOption.isValidYear">{{ sWErrorMessage.invalidYear }}</div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 error date final" id="errorDate">
        <p id="errorContainer">{{ validDateOption.errorMessage }}</p>
      </div>
    </div>
  </div>
</div>
<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>